var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _g6, _path8, _path9, _path10, _g7, _path11, _path12, _g8, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _g9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 109,
    viewBox: "0 0 115 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.621 37.1164L40.7035 30.0648C38.4308 29.8364 36.4035 31.5069 36.1767 33.7966L31.8024 77.8237C31.5583 80.2858 33.339 82.4806 35.779 82.7266L105.088 89.7169C107.528 89.9629 109.705 88.1676 109.951 85.7043L114.325 41.6772C114.553 39.3886 112.894 37.3461 110.621 37.1164Z",
    fill: "#384254"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2525_1491",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 11,
    width: 26,
    height: 82
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0386 11.009L61.0176 90.3057L78.7399 92.1548L86.7609 12.8582L69.0386 11.009Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2525_1491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.3095 42.6381L34.3179 52.4014L112.468 60.5221L113.459 50.7589L35.3095 42.6381Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2525_1491",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 27,
    width: 20,
    height: 71
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0364 27.7194L63.0994 96.251L75.5102 97.545L82.4472 29.0135L70.0364 27.7194Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2525_1491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.1335 56.3744L38.5771 61.8477L106.413 68.8913L106.969 63.418L39.1335 56.3744Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2525_1491",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 43,
    width: 13,
    height: 55
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8373 43.941L58.4524 97.0654L64.951 97.7421L70.3359 44.6176L63.8373 43.941Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2525_1491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.9963 67.5663L37.8877 68.6328L90.7917 74.1152L90.9003 73.0487L37.9963 67.5663Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2525_1491",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 59,
    y: 44,
    width: 13,
    height: 58
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.772 44.978L59.1538 100.402L65.8879 101.104L71.5061 45.6791L64.772 44.978Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2525_1491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.7846 69.6464L37.676 70.7129L92.8742 76.4328L92.9828 75.3663L37.7846 69.6464Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2525_1491",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 49,
    width: 12,
    height: 51
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6559 49.7003L56.6287 99.2979L62.7653 99.9368L67.7925 50.3393L61.6559 49.7003Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2525_1491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5732 71.7254L37.4646 72.792L86.8491 77.91L86.9578 76.8434L37.5732 71.7254Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_2525_1491",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 55,
    width: 11,
    height: 43
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6487 55.2353L53.3938 97.2178L58.7496 97.7755L63.0044 55.7931L57.6487 55.2353Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_2525_1491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.3613 73.8053L37.2527 74.8721L79.0386 79.2034L79.1472 78.1366L37.3613 73.8053Z",
    fill: "white"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8957 2.5635C83.5611 0.932958 81.97 -0.128267 80.3615 0.207579L2.74493 16.4019C1.13646 16.7377 0.094302 18.347 0.430122 19.9788L10.4911 68.9263C10.8269 70.5581 12.4168 71.618 14.0253 71.2822L91.6418 55.0879C93.2503 54.7521 94.2924 53.1427 93.9566 51.511L83.8957 2.5635Z",
    fill: "#106B46"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8188 50.8215L93.6008 49.7553L93.1646 47.6229L91.4185 39.0944L87.9501 22.0336L84.5088 4.96661L84.0788 2.83292L84.0255 2.56574C84.0057 2.47585 83.9797 2.38346 83.9574 2.29232C83.9376 2.19993 83.8967 2.11378 83.8669 2.02389C83.8384 1.934 83.7938 1.85035 83.7529 1.7642C83.5856 1.42461 83.3589 1.11623 83.0838 0.857791C82.5373 0.337167 81.7975 0.021296 81.0416 0.00381701C80.9474 -0.006171 80.8532 0.00631401 80.759 0.00881101C80.6636 0.0100595 80.5707 0.0250415 80.4777 0.0400235L80.3377 0.061248L80.2051 0.0874665L79.9399 0.141152L78.8817 0.357143L70.4118 2.08881L36.5324 9.01924L19.5989 12.5138L2.66911 16.0346C1.87479 16.2019 1.14862 16.6738 0.670294 17.3293C0.187011 17.981 -0.0595875 18.8125 0.0122854 19.6252C0.0135246 19.7276 0.0370692 19.8263 0.0507002 19.9274C0.0581354 19.9761 0.0655705 20.031 0.075484 20.0747L0.102746 20.2083L0.213034 20.7414L0.433609 21.8076L0.873521 23.9388L2.63317 32.4636L6.17601 49.5094L9.74487 66.5489L10.191 68.6788L10.2467 68.9448C10.2678 69.0359 10.2951 69.1333 10.3186 69.2269C10.3397 69.3231 10.3831 69.4117 10.414 69.5041C10.445 69.5977 10.4909 69.6839 10.5342 69.7725C10.709 70.1221 10.9469 70.4392 11.2331 70.7039C11.8019 71.237 12.5653 71.5554 13.3422 71.5678C13.4389 71.5766 13.5355 71.5641 13.6322 71.5604C13.7301 71.5591 13.8255 71.5416 13.9209 71.5267L14.0647 71.5042L14.1973 71.4767L14.4612 71.4205L15.5182 71.1958L23.9745 69.3967L57.8006 62.2016L74.7192 58.6334L91.6428 55.0877L74.7118 58.6059L57.7783 62.1005L23.8989 69.0322L15.429 70.7638L14.3708 70.9811L14.1056 71.0347L13.973 71.061L13.8491 71.0797C13.7673 71.0922 13.6843 71.1072 13.6012 71.1072C13.5182 71.1084 13.4352 71.1209 13.3521 71.1109C12.6879 71.0959 12.0349 70.8163 11.5528 70.3568C11.3112 70.1283 11.1105 69.8562 10.963 69.5578C10.9271 69.4829 10.8874 69.4092 10.8626 69.3293C10.8366 69.2494 10.7994 69.1745 10.7833 69.0921C10.7635 69.0097 10.7412 68.9335 10.7226 68.8474L10.6693 68.5802L10.2393 66.4465L6.79932 49.3795L3.33083 32.3188L1.58482 23.7902L1.14862 21.6578L0.930524 20.5916L0.821475 20.0585L0.794213 19.9249C0.785539 19.8799 0.781821 19.845 0.774386 19.8038C0.764473 19.7251 0.744646 19.6465 0.744646 19.5666C0.688882 18.9311 0.883435 18.2819 1.26263 17.7725C1.63934 17.2593 2.20069 16.896 2.81905 16.7662L19.7426 13.2217L36.6613 9.65348L70.4862 2.45837L78.9424 0.658031L79.9994 0.433301C80.3575 0.354646 80.6896 0.280984 81.0341 0.292221C81.7206 0.302209 82.3972 0.58437 82.9016 1.0563C83.1544 1.29102 83.3651 1.57193 83.52 1.88156C83.5584 1.96022 83.5993 2.03638 83.6265 2.11878C83.6538 2.20118 83.6934 2.27858 83.712 2.36473C83.7331 2.44963 83.7579 2.53078 83.7777 2.61818L83.8335 2.88411L84.2796 5.01405L87.8484 22.0536L91.3913 39.0994L93.1509 47.6254L93.5908 49.7566L93.8114 50.8228C93.8808 51.1786 93.9725 51.5319 94.0047 51.8927C94.0692 52.6156 93.8486 53.356 93.4186 53.9365C92.9911 54.5208 92.3492 54.9391 91.6428 55.0877C92.3492 54.9391 92.9936 54.5221 93.4223 53.9378C93.8535 53.3572 94.0754 52.6169 94.0122 51.8915C93.9787 51.5307 93.8882 51.1773 93.8188 50.8215Z",
    fill: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_2525_1491",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 22,
    width: 79,
    height: 49
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8671 22.9121H14.2183V70.234H92.8671V22.9121Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_2525_1491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.085 22.9121C71.185 49.7137 32.1654 64.5596 14.2183 70.234L90.4891 54.3206C92.0975 53.9848 93.1397 52.3755 92.8039 50.7437L87.085 22.9121Z",
    fill: "white"
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.573 32.2248C22.5458 32.095 22.4194 32.0113 22.2905 32.0375L8.15878 34.9865C8.0299 35.0139 7.94564 35.1413 7.9729 35.2711L10.1402 45.8172C10.1663 45.9471 10.2939 46.0307 10.4228 46.0045L24.5545 43.0555C24.6834 43.0293 24.7664 42.9007 24.7404 42.7709L22.573 32.2248Z",
    fill: "#FE9A30"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_2525_1491",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 36,
    width: 15,
    height: 10
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4242 36.5273H10.6011V45.6876H24.4242V36.5273Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_2525_1491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4577 36.5273C20.6075 40.7086 14.4388 43.7487 10.6011 45.323C11.0348 45.6289 11.585 45.7625 12.1389 45.6464L22.8393 43.4141C23.9112 43.1906 24.6064 42.1169 24.3821 41.0294L23.4577 36.5273Z",
    fill: "white"
  })))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8341 46.2564L10.9556 49.7783L12.0736 55.2174L28.9522 51.6954L27.8341 46.2564Z",
    fill: "#C2D1EF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6603 42.3267L29.7817 45.8486L30.8998 51.2877L47.7784 47.7657L46.6603 42.3267Z",
    fill: "#C2D1EF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4867 38.3989L48.6082 41.9209L49.7262 47.3599L66.6048 43.838L65.4867 38.3989Z",
    fill: "#C2D1EF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3146 34.4712L67.436 37.9932L68.5541 43.4322L85.4327 39.9103L84.3146 34.4712Z",
    fill: "#C2D1EF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7416 8.45872C72.6833 8.6797 71.7725 9.21905 71.0798 9.95442C72.5755 10.5986 73.7478 11.9495 74.1047 13.6849C74.4616 15.4191 73.9176 17.1283 72.7986 18.3181C73.7243 18.7176 74.7726 18.8475 75.8309 18.6265C78.5992 18.0484 80.375 15.3042 79.7988 12.4964C79.2213 9.68849 76.51 7.88066 73.7416 8.45872Z",
    fill: "#FE9A30"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0799 9.95459C69.9609 11.1444 69.4181 12.8536 69.7738 14.5878C70.1306 16.3219 71.3029 17.6728 72.7986 18.3183C73.9176 17.1285 74.4604 15.4193 74.1047 13.6851C73.7478 11.9497 72.5756 10.5988 71.0799 9.95459Z",
    fill: "#FE9A30"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2252 43.7875L50.5193 51.2344L50.8579 52.8823L86.5638 45.4355L86.2252 43.7875Z",
    fill: "#C2D1EF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9539 47.3298L59.6873 53.0166L60.0259 54.6646L87.2925 48.9778L86.9539 47.3298Z",
    fill: "#C2D1EF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3425 40.8328L17.2717 42.3086L16.9148 40.5756C17.7066 40.3696 18.242 40.0201 18.5071 39.5356C18.7005 39.1836 18.7005 38.8477 18.672 38.6442L23.6758 37.6005L23.594 37.2047L18.553 38.2559C18.0957 37.2484 16.9334 37.1935 16.2109 37.3383L15.864 35.6478L22.9695 34.1658L22.8877 33.7701L15.7822 35.252L15.4166 33.4717L15.0263 33.5528L15.3918 35.3332L8.29004 36.8164L8.37182 37.2122L15.4773 35.7302L15.8255 37.4269L8.72004 38.9089L8.80182 39.3047L15.9073 37.8215L15.9098 37.8364L16.1155 37.7778C16.1861 37.759 17.8355 37.3008 18.2544 38.5768C18.2556 38.5805 18.3733 38.9489 18.1602 39.3384C17.9309 39.7554 17.4191 40.0538 16.6385 40.2261L9.30617 41.7555L9.38796 42.1513L16.5282 40.6618L16.8826 42.3897L9.74361 43.8792L9.82539 44.275L16.9644 42.7855L17.3299 44.5659L17.7203 44.4847L17.3547 42.7043L24.4255 41.2286L24.3425 40.8328Z",
    fill: "#FFDCBD"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_2525_1491",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 14,
    width: 13,
    height: 15
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5542 14.6611H1.4436V28.7767H13.5542V14.6611Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_2525_1491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.50703 20.2696L3.25552 28.7781C2.73506 25.1188 2.83296 16.8999 13.5544 14.6626L3.82059 16.6939C2.21337 17.0285 1.17121 18.6378 1.50703 20.2696Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/cardIcon.3c688a2ae99b405354d1903263a7a5bb.svg";
export { ForwardRef as ReactComponent };